const view = /*html*/`

    
    <!--begin::Container-->
    <div id="kt_content_container" class="container-xxl">
        <style>
            .top-rank:nth-of-type(1)::after, .top-rank:nth-of-type(2)::after, .top-rank:nth-of-type(3)::after {
                content: "";
                position: absolute;
                left: 0px;
                top: 0px;
                height: 100%;
                width: 100%;
                z-index: 0;                 
                border: 0;
                box-sizing: border-box;
                color: #fff;
                margin: 0;
                padding: 0;
            }
            .top-rank:nth-of-type(1)::after {
                background: linear-gradient(270deg, rgba(31, 31, 31, 0.4) 60.91%, rgba(52, 49, 43, 0.4) 77.74%, rgba(255, 193, 7, 0.4) 102.88%);
            }
            .top-rank:nth-of-type(2)::after {
                background: linear-gradient(270deg, rgba(31, 31, 31, 0.4) 58.44%, rgba(39, 50, 70, 0.4) 78.79%, rgba(71, 94, 138, 0.4) 100%);
            }
            .top-rank:nth-of-type(3)::after {
                background: linear-gradient(270deg, rgba(31, 31, 31, 0.3) 61.73%, rgba(51, 43, 44, 0.3) 80.47%, rgba(119, 78, 55, 0.3) 100%);
            }

            .top-trophy-1{
                color: #ffc107;
            }
            .top-trophy-2{
                color: #C0C0C0;
            }
            .top-trophy-3{
                color: #CD7F32;
            }
            .table-custom
            {
                border-collapse: separate;
                border-spacing: 0 0.5rem;
            }
            
        </style>
        <div class="card card-flush w-100 bgi-position-x-end bgi-position-y-center mb-6 px-20" style="height:246px;background-image:url('assets/media/misc/bg_ban.png');">
            <div class="d-flex h-100 align-items-center">
                <div class="card-title">
                    <h1 class="fs-2hx text-white teko-header" data-i18n="bans.title">Banlist</h1>
                    <p class="text-gray-700 fs-6" data-i18n="bans.subtitle">The hall of infamy!</p>
                </div>
            </div>            
        </div>        

        <!--begin::FAQ card-->
        <div class="card card-flush">           
            <div class="card-body py-8">
                <!--begin::Table container-->
                <div class="table-responsive">
                    <!--begin::Table-->
                    <table class="table table-custom align-middle gs-0 gy-2">
                        <!--begin::Table head-->
                        <thead>
                            <tr class="fw-bolder text-gray-800 teko-header fs-4" style="background-color: #1b1b1b">
                                <th class="ps-4 rounded-start" data-i18n="stats.player">Player</th>                                 
                                <th class="min-w-75px" data-i18n="bans.since">Since</th>
                                <th class="min-w-75px" data-i18n="bans.until">Until</th>   
                                <th class="min-w-75px" data-i18n="bans.by">By</th>
                                <th class="text-nowrap text-start rounded-end pe-4 min-w-75px" data-i18n="bans.reason">Reason</th> 
                            </tr>
                        </thead>
                        <!--end::Table head-->

                        <!--begin::Table body-->
                        <tbody class="table-bans-body">                            
                            
                        </tbody>
                        <!--end::Table body-->
                    </table>
                    <!--end::Table-->
                </div>
                <!--end::Table container-->
            </div>            

            <div id="bans-list-loader" class="text-center">
                <div class="d-flex justify-content-center pt-10 pb-10">
                    <div class="spinner-border text-primary text-center" role="status" style="width: 3rem; height: 3rem;">
                        <span class="visually-hidden" data-i18n="example.loading">Loading...</span>
                    </div>                                                       
                </div>
                <div class="pb-15 fw-semibold">
                    <h3 class="text-gray-600 fs-5 mb-2" data-i18n="example.loading">Loading...</h3>
                </div>
            </div>
        </div>
        <!--end::FAQ card-->
    </div>
    <!--end::Container-->

`;


export default view;